import * as React from "react";

// DataDetail — v2-plan V6.4. A plain field-list detail view, hand-configured per screen
// (same D7/G7 status as DataList — not schema-driven yet).

export interface DataDetailField {
  label: string;
  value: React.ReactNode;
}

export function DataDetail({ fields, title }: { fields: DataDetailField[]; title?: string }) {
  return (
    <div className="space-y-4">
      {title && <h2 className="text-lg font-semibold">{title}</h2>}
      <dl className="divide-y divide-line">
        {fields.map((f, i) => (
          <div key={i} className="grid grid-cols-3 gap-4 py-2 text-sm">
            <dt className="text-muted">{f.label}</dt>
            <dd className="col-span-2">{f.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
